import React, { Component } from "react"
import { I18nextProvider } from "react-i18next"

import i18nInstance from "./i18n"

const withI18next = () => (Comp) => {
  class I18nHOC extends Component {
    constructor(props) {
      super(props)

      this.i18n = i18nInstance
      this.changeLanguage()
    }

    changeLanguage = () => {
      const page = this.props.data?.single
      const pageListing = this.props.pageContext

      const currentLanguage =
        page && page.language
          ? page.language.slug
          : pageListing && pageListing.pageLanguage
          ? pageListing.pageLanguage.slug
          : "fi"

      this.i18n.changeLanguage(currentLanguage)

      const languageStrings = require("./lang.json")
      const currentLanguageStrings = languageStrings[currentLanguage]
        ? languageStrings[currentLanguage]
        : {}

      if (!this.i18n.hasResourceBundle(currentLanguage, "translation")) {
        this.i18n.addResourceBundle(
          currentLanguage,
          "translation",
          currentLanguageStrings.translation
        )
      }
    }

    render() {
      return (
        <I18nextProvider i18n={i18nInstance}>
          <Comp {...this.props} />
        </I18nextProvider>
      )
    }
  }

  return I18nHOC
}

export default withI18next
